export default "__VITE_ASSET__BEZEEOok__"